import React from "react";
import PropTypes from "prop-types";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const FormSelect = ({
  startAdornment,
  value,
  onChange,
  placeholderText,
  options,
  ...rest
}) => {
  return (
    <FormControl sx={{ width: "100%" }}>
      <Select
        value="0"
        onChange={onChange}
        startAdornment={startAdornment}
        style={{ minHeight: 35 }}
        inputProps={{ "aria-label": "Select Referral Type" }}
        IconComponent={KeyboardArrowDownIcon}
        {...rest}
      >
        <MenuItem value="0">
          {placeholderText}
        </MenuItem>
        {options.map((option, index) => (
          <MenuItem key={index} value={option} style={{ fontSize: "1.25rem" }}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

FormSelect.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholderText: PropTypes.string.isRequired,
  startAdornment: PropTypes.element,
};

export default FormSelect;
